import axios from "axios";
import { store } from "../app/store";
import { authAction, logoutAction } from "../core/auth/authSlice";
import http from "../shared/utils/http";

let isRefreshing = false;
let failedQueue: (() => void)[] = [];

const status401Interceptor = (error: any) => {
	const originalRequest = error.config;

	if (
		error.response?.status === 401 &&
		error.response?.data?.message === "JWT_TOKEN_EXPIRED" &&
		!originalRequest._retry
	) {
		if (isRefreshing) {
			return new Promise((resolve) => {
				failedQueue.push(() => {
					resolve(axios(originalRequest));
				});
			});
		}

		originalRequest._retry = true;
		isRefreshing = true;

		return new Promise(async (resolve, reject) => {
			try {
				await http.post("/auth/refresh", {});

				// Refresh user data after token refresh
				store.dispatch(authAction(() => {}));

				// Retry original + others
				processQueue();

				// Retry the current one
				resolve(axios(originalRequest));
			} catch (err) {
				failedQueue = [];
				reject(err);
			} finally {
				isRefreshing = false;
			}
		});
	}

	if (
		error.response?.status === 403 &&
		error.response?.data?.message === "REFRESH_TOKEN_ERROR"
	) {
		store.dispatch(logoutAction());
		return new Promise(() => {});
	}

	return Promise.reject(error);
};

export default status401Interceptor;

const processQueue = () => {
	failedQueue.forEach((callback) => {
		callback();
	});
	failedQueue = [];
};
